


export const Event_START = 'Event_START';
export const Event_END = 'Event_END';
export const Event_ERROR = 'Event_ERROR';
export const Event_SUCCESS = 'Event_SUCCESS';
export const Event_FAIL  = 'Event_FAIL';
export const IsDataSubmitedSuccessfully = 'IsDataSubmitedSuccessfully'